import { AnyAction } from "redux";

const isErrorAction = (
  action: AnyAction
): action is { type: string; error: Error } => {
  return "error" in action;
};

export default isErrorAction;
